import { QUERY_KEYS } from 'services/constant'
import API from 'api'
import {
  type NewOrderStorePOSTPayload,
  type NewOrderStorePOSTResponse,
} from './types'

export const lojaNovoPedidoLoja = {
  post: async (payload: NewOrderStorePOSTPayload) => {
    return await API.post<NewOrderStorePOSTResponse>(
      QUERY_KEYS.LOJA.NOVO_PEDIDO_LOJA,
      {
        ...payload.order,
        billingAddress: payload.billingAddress,
        deliveryAddress: payload.deliveryAddress,
        confirm_quotation_changes: payload.confirm_quotation_changes,
      },
    )
      .then((res) => res.data)
      .catch((error) => {
        const errorMessage =
          error?.response?.data?.message?.status ??
          error?.response?.data?.message?.message
        throw new Error(
          errorMessage ??
            'Ocorreu um erro, não foi possível finalizar o seu pedido, tente novamente mais tarde.',
        )
      })
  },
}
